import { FaWhatsapp } from "react-icons/fa6";
import {HiOutlineMail} from "react-icons/hi"
import {RiMessengerLine} from "react-icons/ri"

//  contact data
const contactData = [
  {
    id: 1,
    icon: <RiMessengerLine/>,
    link: "https://web.facebook.com/princeley.toochukwu" 
  },
  {
    id: 2,
    icon: <FaWhatsapp/>,
    link: "https://wa.me/+2348142534211" 
  },
  {
    id: 3,
    icon: <HiOutlineMail/>,
    link: "mailto:onuprinceley@gmail.com"
  }
];



export default contactData;
